// avstemming-bank-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avab.flag.notBooked': 'Ikke bokført',
  'avab.flag.manualReview': 'Står til manuell kontroll',
  'avab.flag.missingVoucher': 'Mangler bilag',
  'avab.flag.possibleDuplicate': 'Mulig duplikat',
  'avab.assess.notAssessed': 'Ikke vurdert',
  'avab.assess.noCorrection': 'Ingen korrigering nødvendig',
  'avab.assess.transit': 'Tidsforskjell mot bank',
  'avab.assess.missingBooking': 'Manglende bokføring',
  'avab.assess.wrongBooking': 'Feil bokføring — skal rettes',
  'avab.assess.duplicate': 'Duplikat',
  'avab.assess.internalTransfer': 'Intern overføring',
  'avab.assess.bankFee': 'Bankgebyr',
  'avab.assess.interest': 'Rente',
  'avab.assess.currencyDifference': 'Valutadifferanse',
  'avab.assess.wrongBankAccount': 'Feil bankkonto',
  'avab.assess.shouldReverse': 'Bokføringen skal reverseres',
  'avab.assess.awaitingDocs': 'Avventer dokumentasjon',
  'avab.assess.awaitingClient': 'Avventer klienten',
  'avab.assess.nextPeriod': 'Følges opp neste periode',
  'avab.nav.overview': 'Oversikt',
  'avab.nav.accounts': 'Bankkontoer',
  'avab.nav.accountsCount': '{ok}/{total} stemmer',
  'avab.nav.transactions': 'Transaksjoner',
  'avab.nav.openCount': '{count} åpne',
  'avab.nav.documentation': 'Dokumentasjon',
  'avab.nav.missingCount': '{count} mangler',
  'avab.nav.complete': 'Komplett',
  'avab.nav.deviations': 'Avvik og tiltak',
  'avab.nav.controls': 'Kontroll og godkjenning',
  'avab.noReconciliationAccount': 'Bankkontoen har ingen avstemmingskonto i denne perioden.',
  'avab.bank': 'Bank',
  'avab.activeAccount': 'Bankkonto: {name}',
  'avab.showAllAccounts': 'Vis alle bankkontoer',
  'avab.resetFilters': 'Nullstill filtre',
  'avab.common.description': 'Beskrivelse',
  'avab.common.bankDate': 'Bankdato',
  'avab.common.bookingDate': 'Bokføringsdato',
  'avab.common.voucher': 'Bilag',
  'avab.common.bankAmount': 'Bankbeløp',
  'avab.common.bookedAmount': 'Bokført beløp',
  'avab.common.difference': 'Differanse',
  'avab.common.assessment': 'Vurdering',
  'avab.common.close': 'Lukk',
  'avab.tx.colMatch': 'Match',
  'avab.tx.colFlag': 'Varsel',
  'avab.tx.noFlags': 'Ingen',
  'avab.tx.assess': 'Vurder',
  'avab.tx.viewAssessment': 'Se vurdering',
  'avab.tx.noMatchingLines': 'Ingen banklinjer passer med filtrene.',
  'avab.tx.noStatement': 'Ingen bankutskrift dekker denne perioden. Uten bankgrunnlag kan ikke banken avstemmes.',
  'avab.drawer.noBankMatch': 'Ingen banktreff',
  'avab.drawer.matchStatus': 'Matchstatus',
  'avab.drawer.attachment': 'Vedlegg',
  'avab.drawer.reasonRequired': 'Begrunnelse (påkrevd)',
  'avab.drawer.reason': 'Begrunnelse',
  'avab.drawer.reasonPlaceholder': 'Hva viser gjennomgangen av denne linjen?',
  'avab.drawer.action': 'Tiltak',
  'avab.drawer.actionPlaceholder': 'F.eks. Undersøk eller reverser',
  'avab.drawer.followUpDue': 'Frist for oppfølging',
  'avab.drawer.followUpNote': 'Linjen kommer opp som oppfølgingsforslag under «Konklusjon og godkjenning».',
  'avab.drawer.needsReason': 'Denne vurderingen krever en begrunnelse.',
  'avab.drawer.save': 'Lagre vurdering',
  'avab.drawer.askClient': 'Be klienten om dokumentasjon',
  'avab.common.account': 'Konto',
  'avab.common.date': 'Dato',
  'avab.common.type': 'Type',
  'avab.common.amount': 'Beløp',
  'avab.common.status': 'Status',
  'avab.sections.responsible': 'Ansvarlig {name}',
  'avab.sections.title': 'Bank – hovedbok mot bank',
  'avab.sections.noAccounts': 'Ingen bankkontoer satt opp for avstemming',
  'avab.sections.unassessed': '{count} bankposter krever vurdering før avstemmingen kan sendes til kontroll.',
  'avab.sections.noneUnassessed': 'Ingen bankposter står igjen til vurdering.',
  'avab.sections.notLinked': 'Ingen av bankkontoene er koblet til en hovedbokskonto i denne perioden. Uten koblingen finnes det ingen hovedbokslinjer å sammenlikne bankgrunnlaget med — kontrollen er ikke kjørt, den fant ikke ingenting. Koblingen settes opp under Innstillinger.',
  'avab.cur.title': 'Kontoer i utenlandsk valuta',
  'avab.cur.none': 'Ingen av foretakets bankkontoer føres i utenlandsk valuta. Da finnes det ingen omregning å kontrollere.',
  'avab.cur.noLedgerAccount': 'Bankkontoen har ingen hovedbokskonto i denne perioden.',
  'avab.cur.intro': 'Banken rapporterer saldoen i kontoens valuta, hovedboken fører den i kroner. Differansen mellom dem er en omregning — ikke et avvik i bankgrunnlaget.',
  'avab.cur.bankBalance': 'Banksaldo',
  'avab.cur.rate': 'Kurs {date}',
  'avab.cur.converted': 'Omregnet',
  'avab.cur.booked': 'Bokført',
  'avab.cur.conversionDifference': 'Omregningsdifferanse',
  'avab.cur.noted': 'Notert {date}',
  'avab.cur.noRate': 'Ingen kurs notert',
  'avab.cur.fetchRate': 'Hent kurs',
  'avab.cur.explained': 'Forklart',
  'avab.cur.explain': 'Forklar omregningen',
  'avab.cur.footnote': 'Kursen er Norges Banks notering. Omregningsdifferansen føres som urealisert agio eller disagio — avstemmingen viser den, den bokfører den ikke.',
  'avab.transit.title': 'Bokført uten banktreff',
  'avab.transit.allMatched': 'Alle bokføringer på bankkontoene er funnet igjen i bankutskriften. Ingen poster venter på banken.',
  'avab.transit.intro': 'Posteringer på bankkontoene som ikke er funnet igjen i bankutskriften. Matchingen er et forslag — samme beløp innen seks dager — ikke en bokføringsbeslutning.',
  'avab.transit.kpiItems': 'Poster uten banktreff',
  'avab.transit.kpiNeedsAssessment': '{count} krever vurdering',
  'avab.transit.kpiItemsHint': 'Bokføringer på bankkontoene uten en tilsvarende banklinje.',
  'avab.transit.kpiNormal': 'Normal tidsforskjell',
  'avab.transit.kpiNormalHint': 'Bokført inntil 30 dager før periodeslutt — betalingen kan ennå være underveis.',
  'avab.transit.kpiOld': 'Eldre enn 30 dager',
  'avab.transit.kpiOldHint': 'For gammelt til å være en tidsforskjell. Må undersøkes eller reverseres.',
  'avab.transit.kpiTotal': 'Samlet beløp',
  'avab.transit.kpiTotalHint': 'Beløpet disse posteringene utgjør av differansen mot bank.',
  'avab.transit.colAge': 'Alder',
  'avab.transit.days': '{count} dager',
  'avab.transit.needsAssessment': 'Krever vurdering',
  'avab.transit.timingDifference': 'Tidsforskjell mot bank',
  'avab.int.title': 'Interne overføringer',
  'avab.int.none': 'Ingen bilag i perioden rører to av foretakets egne bankkontoer.',
  'avab.int.offOne': '{count} overføring går ikke opp. Differansen er som regel et gebyr banken trakk underveis, eller en omregning mellom kontoer i ulik valuta — begge deler må bokføres.',
  'avab.int.offMany': '{count} overføringer går ikke opp. Differansen er som regel et gebyr banken trakk underveis, eller en omregning mellom kontoer i ulik valuta — begge deler må bokføres.',
  'avab.int.allOk': 'Alle overføringer mellom foretakets egne bankkontoer går opp.',
  'avab.int.colFrom': 'Fra',
  'avab.int.colTo': 'Til',
  'avab.int.colOut': 'Ut',
  'avab.int.colIn': 'Inn',
  'avab.int.deviation': 'Avvik',
  'avab.int.checked': 'Kontrollert',
  'avab.fees.title': 'Bankgebyrer og renter',
  'avab.fees.none': 'Ingen bilag i perioden fører gebyr eller rente mot bankkontoene. Et gebyr banken har trukket uten at det er bokført vises som en ikke bokført banklinje i transaksjonslista.',
  'avab.fees.intro': 'Hentet fra hovedboken — bilag som rører en bankkonto og en gebyr- eller rentekonto. Gebyrer banken har trukket uten at de er bokført vises som ikke bokførte banklinjer i transaksjonslista.',
  'avab.fees.colCount': 'Antall',
  'avab.fees.sum': 'Sum',
  'avab.fees.items': 'Postene',
  'avab.fees.colText': 'Tekst',
  'avab.fees.kind.fee': 'Gebyr',
  'avab.fees.kind.interestIncome': 'Renteinntekt',
  'avab.fees.kind.interestExpense': 'Rentekostnad',
  'avab.quick.requiresAssessment': 'Krever vurdering',
  'avab.quick.all': 'Alle',
  'avab.quick.matched': 'Matchet',
  'avab.quick.suggested': 'Foreslått match',
  'avab.quick.manualReview': 'Til manuell kontroll',
  'avab.quick.unmatchedBank': 'Umatchet bank',
  'avab.quick.notBooked': 'Ikke bokført',
  'avab.quick.missingVoucher': 'Mangler bilag',
  'avab.quick.possibleDuplicates': 'Mulige duplikater',
  'avab.quick.held': 'Holdt utenfor',
  'avab.quick.assessed': 'Ferdig vurdert',
  'avab.bal.title': 'Automatisk saldoavstemming',
  'avab.bal.noComparable': 'Ingen kontoer kan sammenliknes',
  'avab.bal.settledBadge': 'Saldo avstemt etter poster i transitt',
  'avab.bal.unexplainedBadge': 'Uforklart differanse',
  'avab.bal.noComparableText': 'Ingen bankkonto har både bokført saldo og banksaldo i denne perioden. Uten begge sidene finnes det ingen differanse å avstemme.',
  'avab.bal.bookedAll': 'Bokført saldo, alle bankkontoer',
  'avab.bal.bankPerDate': 'Saldo ifølge bank per {date}',
  'avab.bal.preliminary': 'Foreløpig differanse',
  'avab.bal.bookedWithoutMatch': 'Bokført uten banktreff',
  'avab.bal.unexplained': 'Uforklart differanse',
  'avab.bal.settledText': 'Bokført saldo og banksaldo kan avstemmes etter {amount} i posteringer som ennå ikke er funnet igjen i banken. Hver av dem må fortsatt vurderes.',
  'avab.bal.unexplainedText': '{amount} av differansen er ikke forklart av poster i transitt og må undersøkes.',
  'avab.bal.excluded': '{count} konto er holdt utenfor sammenlikningen — valutakonto eller manglende bankgrunnlag.',
  'avab.bal.previousBalance': 'Saldo forrige periode',
  'avab.bal.change': 'Endring i perioden',
  'avab.bal.bankTransactions': 'Banktransaksjoner',
  'avab.bal.bookedTransactions': 'Bokførte banktransaksjoner',
  'avab.bal.notBooked': 'Ikke bokført',
  'avab.bal.coverageComplete': 'Bankgrunnlag komplett',
  'avab.bal.coveredOf': '{covered} av {total}',
  'avab.bal.basisNote': 'Grunnlaget er bankutskriftene som dekker {from} til {to}, og saldobalansen for samme periode.',
  'avab.cov.title': 'Dokumentasjonsdekning per bankkonto',
  'avab.cov.incompleteOne': 'Bankgrunnlaget dekker ikke hele perioden for {count} bankkonto.',
  'avab.cov.incompleteMany': 'Bankgrunnlaget dekker ikke hele perioden for {count} bankkontoer.',
  'avab.cov.colBankAccount': 'Bankkonto',
  'avab.cov.colFrom': 'Fra dato',
  'avab.cov.colTo': 'Til dato',
  'avab.cov.colCoverage': 'Dekning',
  'avab.cov.colSource': 'Kilde',
  'avab.cov.noStatement': 'Ingen utskrift',
  'avab.cov.incomplete': 'Ufullstendig',
  'avab.cov.requestStatement': 'Be om kontoutskrift for {account}',
  'avab.ctl.ledgerVsBank': 'Hovedbok mot bank',
  'avab.ctl.settledOf': '{settled} av {total} avstemt',
  'avab.ctl.ledgerVsBankHint': 'Bokført saldo sammenliknet med banksaldo per bankkonto.',
  'avab.ctl.unbookedLines': 'Ikke bokførte banklinjer',
  'avab.ctl.unbookedLinesHint': 'Banklinjer uten tilsvarende bokføring.',
  'avab.ctl.olderThan30': '{count} eldre enn 30 dager',
  'avab.ctl.noMatchHint': 'Posteringer på bankkontoene som ikke er funnet igjen i bankutskriften.',
  'avab.ctl.manualHint': 'Banklinjer bankflaten har satt til manuell kontroll.',
  'avab.ctl.duplicateHint': 'Samme konto, dato, beløp og tekst.',
  'avab.ctl.missingDocs': 'Manglende dokumentasjon',
  'avab.ctl.bankAccountOne': 'bankkonto',
  'avab.ctl.bankAccountMany': 'bankkontoer',
  'avab.ctl.missingDocsHint': 'Bankkonto med ufullstendig periodedekning.',
  'avab.ctl.missingVoucherHint': 'Utbetalinger uten vedlegg, uten fritak og uten at bankutskriften er godkjent som bilag.',
  'avab.ctl.internalDeviations': 'Interne overføringer med avvik',
  'avab.ctl.internalDeviationsHint': 'Overføring mellom foretakets egne bankkontoer som ikke går opp.',
  'avab.ctl.feeItems': 'Gebyr- og renteposter',
  'avab.ctl.feeItemsHint': 'Bilag som rører en bankkonto og en gebyr- eller rentekonto.',
  'avab.ctl.foreignHint': 'Kontoer der banksaldoen må regnes om før den kan sammenliknes.',
  'avab.ctl.linesInPeriod': 'Banklinjer i perioden',
  'avab.ctl.linesInPeriodHint': 'Alle linjer i bankgrunnlaget for perioden.',
  'avab.ctl.bookedLines': 'Bokførte banklinjer',
  'avab.ctl.bookedLinesHint': 'Banklinjer som er matchet mot en bokføring.',
  'avab.ctl.title': 'Kontrollkort',
  'avab.ctl.summary': 'Automatiske kontroller kjørt: {run} av {total} · Kontroller med funn: {findings} · Poster med varsel: {flagged}',
  'avab.ctl.hide': 'Skjul',
  'avab.ctl.showAll': 'Vis alle automatiske kontroller',
  'avab.ctl.activeFilter': 'Aktivt filter: {flag} · {count} poster',
  'avab.ctl.removeFilter': 'Fjern filter',
  'avab.checks.title': 'Automatiske kontroller',
  'avab.checks.intro': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De sier hva den som krysser av bør ha sett på.',
  'avab.checks.colCheck': 'Kontroll',
  'avab.checks.colRun': 'Kjøring',
  'avab.checks.colFindings': 'Funn',
  'avab.checks.run': 'Kjørt',
  'avab.checks.findings': '{count} funn',
  'avab.checks.noFindings': 'Ingen funn',
  'avab.match.title': 'Matchingsoversikt',
  'avab.match.remainingOne': '{pct} % av periodens poster er koblet. {count} post står igjen.',
  'avab.match.remainingMany': '{pct} % av periodens poster er koblet. {count} poster står igjen.',
  'avab.acc.status.currency': 'Valuta må kontrolleres',
  'avab.acc.notCompared': 'Ikke sammenliknet',
  'avab.acc.status.agrees': 'Stemmer',
  'avab.acc.status.reconciled': 'Avstemt',
  'avab.acc.intro': 'Klikk en rad for å filtrere hele flaten til den ene bankkontoen.',
  'avab.acc.colCurrency': 'Valuta',
  'avab.acc.colBookedBalance': 'Bokført saldo',
  'avab.acc.colExplained': 'Forklart',
  'avab.acc.colUnexplained': 'Uforklart',
  'avab.acc.lineCount': '{count} linjer',
  'avab.acc.requiresConversion': 'Krever omregning',
  'avab.acc.incompleteBasis': 'Ufullstendig bankgrunnlag',
  'avab.acc.openAccount': 'Åpne konto',
  'avab.acc.noAccounts': 'Foretaket har ingen bankkontoer satt opp for avstemming. Kontoene settes opp under Innstillinger.',
  'avab.derived.notBooked': 'Ikke bokførte banklinjer er behandlet',
  'avab.derived.manualReview': 'Banklinjer til manuell kontroll er behandlet',
  'avab.derived.missingVoucher': 'Utbetalinger uten bilag er behandlet',
  'avab.derived.possibleDuplicate': 'Mulige duplikater er vurdert',
  'avab.chk.title': 'Faglig sjekkliste',
  'avab.chk.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avab.chk.noItems': 'Ingen kontrollpunkter er definert for bank i denne perioden.',
  'avab.chk.intro': 'Punktene gjelder hele bankområdet. En avkryssing lagres på alle bankkontoene i perioden.',
  'avab.chk.groupItems': 'Poster som krever behandling',
  'avab.chk.countOf': '{done} av {total}',
  'avab.chk.processedOf': '{done} av {total} behandlet',
  'avab.chk.notApplicable': 'Ikke aktuelt denne perioden',
  'avab.chk.followsAssessments': 'Følger av vurderingene',
  'avab.chk.groupAssessments': 'Overordnede faglige vurderinger',
  'avab.chk.groupReady': 'Klarstilling',
  'avab.chk.performedBy': 'Utføres av {name}',
  'avab.chk.completedOf': '{done} av {total} kontrollpunkter fullført',
  'avab.blk.linesOne': '{count} banklinje krever vurdering',
  'avab.blk.linesMany': '{count} banklinjer krever vurdering',
  'avab.blk.unexplained': '{amount} av differansen mot bank er uforklart',
  'avab.blk.coverageOne': '{count} bankkonto har ufullstendig bankgrunnlag',
  'avab.blk.coverageMany': '{count} bankkontoer har ufullstendig bankgrunnlag',
  'avab.blk.staleOne': '{count} bokføring uten banktreff er eldre enn 30 dager',
  'avab.blk.staleMany': '{count} bokføringer uten banktreff er eldre enn 30 dager',
  'avab.blk.checklistOne': '{count} kontrollpunkt gjenstår',
  'avab.blk.checklistMany': '{count} kontrollpunkter gjenstår',
  'avab.concl.title': 'Konklusjon og godkjenning',
  'avab.concl.label': 'Konklusjon',
  'avab.concl.placeholder': 'Hva viser gjennomgangen av banken for denne perioden?',
  'avab.concl.note': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avab.concl.remainingRisk': 'Gjenstående risiko',
  'avab.concl.nothingLeft': 'Ingenting står igjen som hindrer at området sendes til kontroll.',
  'avab.concl.followUp': 'Oppfølging neste periode',
  'avab.concl.noFollowUps': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'avab.concl.followedUp': 'Følges opp',
  'avab.concl.action': 'Tiltak: {action}',
  'avab.concl.noAction': 'Ingen tiltak notert',
  'avab.concl.deadline': 'Frist {date}',
  'avab.concl.openAssessment': 'Åpne vurdering',
  'avab.concl.sendToControl': 'Send området til kontroll',
  'avab.concl.oneLeft': 'Én ting står igjen før området kan sendes.',
  'avab.concl.manyLeft': '{count} ting står igjen før området kan sendes.',
});
